import { useEffect, useMemo, useState } from "react";
import { TDeviceMessages, useDevices } from "../../../context/DeviceProvider";
import Button from "../../../components/shared/ui/Button/baseBtn";
import { useTranslation } from "react-i18next";
import { formatdDate } from "../../../lib/utils";
import { PaginationDevicesMessages } from "../../../components/pagination-devices-messages/PaginationDevicesMessages";

function DevicesMessages() {
    const { t } = useTranslation();
    const i18nDeviceDirectory = (key: string): string =>
        t(`device-directory.${key}`);

    const [deviceAllMessages, setDeviceAllMessages] = useState<TDeviceMessages[]>([]);
    const [deviceAllMessagesCount, setDeviceAllMessagesCount] = useState(0);
    const [page, setPage] = useState(1);

    const {
        getDeviceLatestMessages,
        getAllDeviceMessages,
        deviceDetail,
        deviceMessages,
    } = useDevices();

    const limit = 50;
    const view50ButtonDisabled = !!(deviceAllMessages.length && (deviceAllMessagesCount <= deviceAllMessages.length))

    const messagesList = useMemo(() => {
        if (deviceAllMessages?.length > 0) {
            const start = (page - 1) * limit;
            const end = page * limit;
            return deviceAllMessages.slice(start, end);
        }
        return deviceMessages || [];
    }, [deviceAllMessages, deviceMessages, page]);

    useEffect(() => {
        if (deviceDetail?.id) {
            getDeviceLatestMessages(deviceDetail.id);
            setDeviceAllMessages([]);
            setDeviceAllMessagesCount(0);
        }
    }, [deviceDetail?.id])

    const getAllMessages = async () => {
        if (deviceDetail?.id && !view50ButtonDisabled) {
            const response = await getAllDeviceMessages(deviceDetail.id, deviceAllMessages.length);

            setDeviceAllMessages([...deviceAllMessages, ...(response?.results || [])]);
            setDeviceAllMessagesCount(response?.count || 0)

            const newTotal = deviceAllMessages.length
            const newLastPage = Math.ceil(newTotal / limit);
            setPage(newLastPage + 1);
        }
    };

    return (
        <div className="relative h-full">
            <div className="w-full p-4 bg-white h-[calc(100%-64px)] overflow-auto flex flex-col justify-between items-start gap-4 font-montserrat">
                {deviceAllMessages.length > limit && (
                    <PaginationDevicesMessages
                        limit={limit}
                        total={deviceAllMessages.length}
                        page={page}
                        setPage={setPage}
                    />
                )}

                <div className="w-full max-w-md relative flex flex-col justify-start items-start gap-4">
                    <div className="absolute left-2.5 top-5 bottom-0 w-px bg-background-light-gray z-40"></div>

                    {messagesList?.map((item: any, index: number) => (
                        <div key={index} className="w-full flex z-50 justify-start items-start gap-3">
                            <div className="w-5 h-5  bg-background-light-gray rounded-full  flex justify-center items-center gap-1 flex-shrink-0">
                                <div className="w-2 h-2 bg-primeblue rounded-full"></div>
                            </div>

                            <div className="flex-1 max-w-3xl flex flex-col justify-start items-start gap-1">
                                <div className="w-full text-custom-gray text-xs font-medium leading-[18px] break-words">
                                    {formatdDate(item.created_stamp) || '-'}
                                </div>
                                <div className="w-full text-custom-dark text-sm font-normal leading-[22px] break-words">
                                    {item.message_type}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="w-full h-[64px] flex border-t bg-white p-3 gap-2 z-50 justify-end">
                <Button
                    type="submit"
                    size="sm"
                    onClick={getAllMessages}
                    disabled={view50ButtonDisabled}
                >
                    {i18nDeviceDirectory('view-next-logs')}
                </Button>
            </div>
        </div>
    );
}

export default DevicesMessages;